import {createContext} from "react";
import {Calendar} from "../../api/grs";

export const CalendarContext = createContext<Calendar | null | undefined>(null);
